// src/lib/submitLead.js
// Sends form submissions to Formspree. All leads land in the same inbox;
// the `_source` field tells you what kind of submission it was.
const FORMSPREE_ID = 'xnngvgnd';
const ENDPOINT = `https://formspree.io/f/${FORMSPREE_ID}`;

export async function submitLead(payload) {
  const res = await fetch(ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    let msg = 'Submission failed. Please try again.';
    try {
      const data = await res.json();
      if (data?.errors?.length) msg = data.errors.map((e) => e.message).join(', ');
    } catch (_) {
      /* ignore parse errors */
    }
    throw new Error(msg);
  }

  return res.json().catch(() => ({}));
}
